import React, { useContext, useEffect, useState} from 'react'
import './sidebar.scss'
import Dashboard from '@mui/icons-material/Dashboard';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import StoreIcon from '@mui/icons-material/Store';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import BarChartIcon from '@mui/icons-material/BarChart';
import ListIcon from '@mui/icons-material/List';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import ReviewsIcon from '@mui/icons-material/Reviews';
import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import RedeemIcon from '@mui/icons-material/Redeem';
import PaymentIcon from '@mui/icons-material/Payment';
import ChatIcon from '@mui/icons-material/Chat';
import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined';
import EmailIcon from '@mui/icons-material/Email';
import GradingIcon from '@mui/icons-material/Grading';
// import PsychologyIcon from '@mui/icons-material/Psychology';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import SettingsIcon from '@mui/icons-material/Settings';
import LiquorIcon from '@mui/icons-material/Liquor';
import CampaignIcon from '@mui/icons-material/Campaign';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import LogoutIcon from '@mui/icons-material/Logout';
import { NavLink, Link } from 'react-router-dom'
import { DarkModeContext } from '../../context/darkModeContext';
import ContactsIcon from '@mui/icons-material/Contacts';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import {signOut } from "firebase/auth";
// import BarChartIcon from '@mui/icons-material/BarChart';
import { auth, db } from '../../firebase'
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import ScoreboardIcon from '@mui/icons-material/Scoreboard';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import GroupsIcon from '@mui/icons-material/Groups';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';

import BrightnessLowIcon from '@mui/icons-material/BrightnessLow';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import StarIcon from '@mui/icons-material/Star';
import WeekendIcon from '@mui/icons-material/Weekend';



const Sidebar = () => {

  const { darkMode, dispatch : setDarkMode } = useContext(DarkModeContext)

  const { currentUser } = useContext(AuthContext)

  const user = currentUser.uid;

  const [adminRole, setAdminRole] = useState("")

  console.log('user info: ', user)

  
  
  const getAdminRole = async() => {
  
        const docRef = doc(db, "admins", user);
  
        const docSnap = await getDoc(docRef);
  
        
        if (docSnap.exists()) {
  
          // console.log("Document data:", docSnap.data());
          setAdminRole(docSnap.data().role)
          // console.log(userData)
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
    }

    useEffect(()=>  {

      getAdminRole()

    }, [])


  const adminNav = [
    { id : 1, text : "Dashboard", link: "/", iconName : Dashboard, heading:"LIST"},
    { id : 2, text : "Users", link: "/customers", iconName : PeopleOutlineIcon, heading:""},
    { id : 3, text : "Subscribers", link: "/subscribers", iconName : SubscriptionsOutlinedIcon, heading:"OUTLETS"},
    { id : 4, text : "All", link: "/outlets", iconName : Inventory2Icon, heading:""},
    { id : 6, text : "Paid", link: "/paid", iconName : Inventory2Icon, heading:""},
    { id : 5, text : "Unpaid", link: "/unpaid", iconName : Inventory2Icon, heading:"NOTIFICATION"},
    { id : 7, text : "Group", link: "/group", iconName : NotificationsNoneIcon, heading:"USEFUL"},
    { id : 8, text : "Loyalty Reward", link: "/reward", iconName : LoyaltyIcon },
    { id : 9, text : "Points Center", link: "/coin", iconName : ScoreboardIcon},
    
    { id : 10, text : "Reward Location", link: "/rewardlocation", iconName : LocationCityIcon },
    { id : 11, text : "Events", link: "/events", iconName : LiquorIcon, heading:""},
    { id : 12, text : "Adverts", link: "/adverts", iconName : CampaignIcon, heading:""},

    { id : 13, text : "Reviews", link: "/reviews", iconName : ReviewsIcon, heading:""},
    { id : 13, text : "Contacts", link: "/contacts", iconName : ContactsIcon, heading:""},
    { id : 14, text : "Messages", link: "/messages", iconName : EmailIcon, heading:"WHAT NEXT?"},
    { id : 15, text : "Releases", link: "/releases", iconName : RedeemIcon, heading:"SERVICES"},
    { id : 16, text : "Staff", link: "/staff", iconName : PermIdentityIcon, heading:""},
    { id : 17, text : "Partners", link: "/partnerReward", iconName : GroupsIcon, heading:"FEEDBACK"},
    { id : 18, text : "Standard Messages", link: "/standardmessages", iconName : BrightnessLowIcon, heading:""},
    { id : 18, text : "Premium Messages", link: "/premiummessages", iconName : WorkspacePremiumIcon, heading:""},
    { id : 18, text : "Luxury Messages", link: "/luxurymessages", iconName : StarIcon, heading:""},
    { id : 18, text : "Weekend Messages", link: "/weekendmessages", iconName : WeekendIcon, heading:"USER"},
    { id : 19, text : "Settings", link: "/settings", iconName : SettingsIcon, heading:""},
    { id : 20, text : "Profile", link: "/profile", iconName : PermIdentityIcon, heading:""},
  ]



    const subadminNav = [
    { id : 1, text : "Dashboard", link: "/", iconName : Dashboard, heading:"LIST"},
    { id : 2, text : "Users", link: "/customers", iconName : PeopleOutlineIcon, heading:""},
    { id : 3, text : "Subscribers", link: "/subscribers", iconName : SubscriptionsOutlinedIcon, heading:"OUTLETS"},
    { id : 4, text : "All", link: "/outlets", iconName : Inventory2Icon, heading:""},
    { id : 5, text : "Paid", link: "/paid", iconName : Inventory2Icon, heading:""},
    { id : 6, text : "Unpaid", link: "/unpaid", iconName : Inventory2Icon, heading:"NOTIFICATION"},
    { id : 7, text : "Group", link: "/group", iconName : NotificationsNoneIcon, heading:"USEFUL"},
    { id : 8, text : "Loyalty Reward", link: "/reward", iconName : LoyaltyIcon },
    { id : 9, text : "Points Center", link: "/coin", iconName : ScoreboardIcon},
    { id : 10, text : "Reward Location", link: "/rewardlocation", iconName : LocationCityIcon },
    { id : 11, text : "Events", link: "/events", iconName : LiquorIcon, heading:""},
    { id : 12, text : "Adverts", link: "/adverts", iconName : CampaignIcon, heading:""},
    { id : 13, text : "Reviews", link: "/reviews", iconName : ReviewsIcon, heading:""},
    { id : 14, text : "Messages", link: "/messages", iconName : EmailIcon, heading:"WHAT NEXT?"},
    { id : 15, text : "Releases", link: "/releases", iconName : RedeemIcon, heading:"USER"},
    { id : 13, text : "Contacts", link: "/contacts", iconName : ContactsIcon, heading:""},
    { id : 16, text : "Partners", link: "/partnerReward", iconName : GroupsIcon, heading:""},
    { id : 17, text : "Engagement Analysis", link: "/engagementAnalysis", iconName : StackedLineChartIcon, heading:""},
    { id : 18, text : "Profile", link: "/profile", iconName : PermIdentityIcon, heading:""},
  ]



  const agencyNav = [
    { id : 1, text : "Dashboard", link: "/", iconName : Dashboard, heading:"LIST"},
    { id : 2, text : "Users", link: "/customers", iconName : PeopleOutlineIcon, heading:""},
    { id : 2, text : "Subscribers", link: "/subscribers", iconName : SubscriptionsOutlinedIcon, heading:"OUTLETS"},
    { id : 3, text : "All", link: "/outlets", iconName : Inventory2Icon, heading:""},
    { id : 4, text : "Paid", link: "/paid", iconName : Inventory2Icon, heading:""},
    { id : 5, text : "Unpaid", link: "/unpaid", iconName : Inventory2Icon, heading:"USER"},
    { id : 6, text : "Profile", link: "/profile", iconName : PermIdentityIcon, heading:""},
  ]



  const navigate = useNavigate()

  const { logout, dispatch : setLogout} = useContext(AuthContext)

  const { isActive, setIsActive } = useState(null)

 

  const logOut = () =>{

    signOut(auth).then(() => {

      setLogout({ type: 'LOGOUT' });

      localStorage.removeItem('currentUser');

      navigate('/login')

    }).catch((error) => {

      console.log(error)

    });

  }



  return (

    <div className='sidebar'>

      <div className='top-sidebar'>

          <div className="top">

            <Link to="/" style={{textDecoration:'none'}}>

                <span className='logo'>CHILLAXIA ADMIN</span>

            </Link>
            
          </div>
          <hr />
          <div className="center">
            <ul>
              <p className='title'>MAIN</p>


              {

               adminRole === "adminAccess"
               
               
               ?
              
              
              adminNav.map((value) => (
                  <>
                   
                   <li key = {value.id} >
                      <NavLink to={value.link} style={({ isActive }) => ({
                        backgroundColor: isActive &&  "#ece8ff",
                        textDecoration:"none",
                        display:"flex",
                        width:"100%",
                        height:"100%",
                        padding:"5px",
                      })}>
                      <value.iconName className='icon'/>
                      <span>{value.text}</span>
                      </NavLink>
                      
                    </li>
                    {value.heading !== "" && <p className='title'>{value.heading}</p>}
                  </>
                
              ))

              :

              adminRole === "subadminAccess"

              ?


               subadminNav.map((value) => (
                  <>
                   
                   <li key = {value.id} >
                      <NavLink to={value.link} style={({ isActive }) => ({
                        backgroundColor: isActive &&  "#ece8ff",
                        textDecoration:"none",
                        display:"flex",
                        width:"100%",
                        height:"100%",
                        padding:"5px",
                      })}>
                      <value.iconName className='icon'/>
                      <span>{value.text}</span>
                      </NavLink>
                      
                    </li>
                    {value.heading !== "" && <p className='title'>{value.heading}</p>}
                  </>
                
              ))

              :

              agencyNav.map((value) => (

                  <>
                   
                   <li key = {value.id} >
                      <NavLink to={value.link} style={({ isActive }) => ({
                        backgroundColor: isActive &&  "#ece8ff",
                        textDecoration:"none",
                        display:"flex",
                        width:"100%",
                        height:"100%",
                        padding:"5px",
                      })}>
                      <value.iconName className='icon'/>
                      <span>{value.text}</span>
                      </NavLink>
                      
                    </li>
                    {value.heading !== "" && <p className='title'>{value.heading}</p>}
                  </>
                
              ))
              
              
              }
          
              
            </ul>
          </div>
          <div className="bottom">
            <div className="colorOption" onClick={() => setDarkMode({type:"LIGHT"})}></div>
            <div className="colorOption" onClick={() => setDarkMode({type:"DARK"})}></div>
          </div> 
      </div>
      <div className='bottom-sidebar'>
            <LogoutIcon className='logout-icon'/>
            <span onClick={logOut}>Logout</span>
      </div>
    </div>
  )
}

export default Sidebar